// Copyright 2022 The Parca Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useLocalStorage } from '@rehooks/local-storage';
var USER_PREFERENCES_KEY = 'user-preferences';
export var USER_PREFERENCES = {
    HIGHTLIGHT_AFTER_FILTERING: {
        name: 'Highlight matching nodes after filtering',
        key: 'HIGHTLIGHT_AFTER_FILTERING',
        type: 'boolean',
        default: true,
    },
    ENABLE_GRAPH_TRIMMING: {
        name: 'Enable trimming of nodes that are too small to be seen',
        key: 'ENABLE_GRAPH_TRIMMING',
        type: 'boolean',
        default: false,
    },
    FLAMEGRAPH_COLOR_PROFILE: {
        name: 'Flamegraph color profile',
        key: 'FLAMEGRAPH_COLOR_PROFILE',
        type: 'string',
        default: 'default',
    },
};
var useUserPreference = function (preferenceName) {
    var _a;
    var _b = useLocalStorage(USER_PREFERENCES_KEY, {}), flags = _b[0], setFlags = _b[1];
    var value = (_a = flags[preferenceName]) !== null && _a !== void 0 ? _a : USER_PREFERENCES[preferenceName].default;
    var setFlag = function (flag) {
        var _a;
        setFlags(__assign(__assign({}, flags), (_a = {}, _a[preferenceName] = flag, _a)));
    };
    return [value, setFlag];
};
export default useUserPreference;
